import React, { useState } from 'react';
import stored from 'components/hoc/stored';
import themed from 'components/hoc/themed';
import ApplicationSubmitted from './ApplicationSubmitted';
import ApplicationSaved from './ApplicationSaved';
import styled from 'styled-components';
import InAppFeedbackForm from 'components/ui/InAppFeedbackForm';
import Close from 'components/ui/icons/Close';
import FeedbackForm from 'resources/feedback_form/FeedbackForm';
import { URLS } from 'consts';

export const BidModalStyles = styled.div`
  .title {
    font-size: 2.25rem;
    font-weight: ${({ theme }) => theme.fontWeights.fontMedium};
  }
`;

export const CloseButton = styled.a`
  position: absolute;
  top: -2.5rem;
  right: 0;
`;

const BidModalPrompts = () => {
  const [visible, setVisible] = useState(false);
  const [bidStatus, setBidStatus] = useState('');

  const setVisibleAndBidStatus = modal => {
    // the modal change is triggered here after the MutationObserver is called
    // TODO: find a better way to do this
    const status = document.querySelector('.modal .bid-status').innerText;
    setVisible(modal.style.display === 'block');
    setBidStatus(status);
  };

  const observeModalAttributeChange = func => {
    const modal = document.querySelector('.modal');
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          func(modal);
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
    });
  };

  observeModalAttributeChange(setVisibleAndBidStatus);

  return (
    <>
      {visible && (
        <BidModalStyles className="px-0 px-md-4 position-relative">
          {bidStatus.match(/submitted/i) ? (
            <FeedbackForm where={{ name: 'application_assessment' }}>
              {(feedbackForm, loaded) =>
                loaded && feedbackForm.heading ? (
                  <>
                    <CloseButton
                      href={URLS.talentMarketplace}
                      id="job-search-link"
                    >
                      <Close title="Return to job search" />
                    </CloseButton>
                    <InAppFeedbackForm formData={feedbackForm} dialog={false} />
                  </>
                ) : (
                  <ApplicationSubmitted />
                )
              }
            </FeedbackForm>
          ) : (
            <ApplicationSaved />
          )}
        </BidModalStyles>
      )}
    </>
  );
};

export default themed(stored(BidModalPrompts));
